<ng-template #templateRef let-modal>
  <div class="modal-header">
    <h3 class="modal-title">{{ 'store-products-new.title' | transloco }}</h3>

    <button class="close" type="button" (click)="modal.dismiss()">
      <span>×</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="isLoading.form">
    <div class="m-page-loader m-page-loader--non-block m-page-loader--relative">
      <div class="m-loader m-loader--brand"></div>
    </div>
  </div>

  <div class="modal-body" *ngIf="!isLoading.form">
<!--    <div class="text-right">-->
<!--      <button *ngIf="isEdit" class="btn btn-success btn-sm" (click)="syncProduct()">-->
<!--        Синхронизировать продукт-->
<!--      </button>-->
<!--    </div>-->

    <div *ngIf="!isLoading.form">
      <form class="m-form m-form--state m-form--label-align-right" [formGroup]="unitForm" (ngSubmit)="onSubmitForm(modal)">
        <div class="m-portlet__body" *ngIf="unitForm">
          <div class="m-form__section m-form__section--first m-form--label-align-right">
            <div class="form-group m-form__group row">
              <label class="col-form-label col-lg-4 col-md-4 col-sm-12">
                {{ 'store-products-new.product' | transloco }}:
              </label>

              <div class="col-lg-8 col-md-8 col-sm-12">
                <div class="m--margin-top-5" [title]="'store-products-new.change' | transloco">{{ product?.productInfo?.title | uiLabel }}</div>
              </div>
            </div>

            <div class="form-group m-form__group row">
              <label class="col-form-label col-lg-4 col-md-4 col-sm-12">
                {{ 'store-products-new.shop' | transloco }}:
              </label>

              <div class="col-lg-8 col-md-8 col-sm-12">
                <div [title]="'store-products-new.change' | transloco">
                  <div class="m--margin-top-5" *ngIf="store">{{ store.title | uiLabel }}</div>
                </div>
              </div>
            </div>

            <div class="form-group m-form__group row">
              <label class="col-form-label col-lg-4 col-md-4 col-sm-12 is--required">
                {{ 'store-products-new.quantity' | transloco }}:
              </label>
              <div class="col-lg-8 col-md-8 col-sm-12">
                <input formControlName="amount" type="text" class="form-control m-input" placeholder="">
              </div>
            </div>

            <div class="form-group m-form__group row">
              <label for="forSale" class="m--margin-bottom-0 col-form-label col-lg-4 col-md-4 col-sm-12 is--required">
                {{ 'store-products-new.sale' | transloco }}:
              </label>
              <div class="col-lg-8 col-md-8 col-sm-12">
                <span class="m-switch m-switch--icon m-switch--outline  m-switch--success ">
                  <label class="m--margin-bottom-0">
                    <input type="checkbox" formControlName="forSale" id="forSale">
                    <span></span>
                  </label>
                </span>

                <span *ngIf="product?.productInfo">
                  ({{ 'store-products-new.globalSale' | transloco }} <span *ngIf="product?.productInfo.globalForSale">{{ 'store-products-new.enabled' | transloco }}</span> <span *ngIf="!product?.productInfo.globalForSale">{{ 'store-products-new.off' | transloco }}</span>)
                </span>
              </div>
            </div>

            <div class="form-group m-form__group row">
              <label for="forSale" class="m--margin-bottom-0 col-form-label col-lg-4 col-md-4 col-sm-12 is--required">
                {{ 'store-products-new.sellingOnline' | transloco }}:
              </label>

              <div class="col-lg-8 col-md-8 col-sm-12">
                <span class="m-switch m-switch--icon m-switch--outline  m-switch--success">
                  <label class="m--margin-bottom-0">
                    <input type="checkbox" formControlName="onlineSellable" id="onlineSellable">
                    <span></span>
                  </label>
                </span>

                <span *ngIf="product?.productInfo">
                  ({{ 'store-products-new.globalSale' | transloco }} <span *ngIf="product?.productInfo.onlineSellable">{{ 'store-products-new.enabled' | transloco }}</span> <span *ngIf="!product?.productInfo.onlineSellable">{{ 'store-products-new.off' | transloco }}</span>)
                </span>
              </div>
            </div>

            <div class="hc-group">
              <div class="hc-group__info">
                {{ 'store-products-new.accept' | transloco }}:
              </div>

              <div class="row row-margin">
                <div class="col-md-3 col-sm-6">
                  <label>
                    {{ 'store-products-new.days' | transloco }}:
                  </label>
                  <input type="text" formControlName="minOrderDay" class="form-control m-input" [placeholder]="'store-products-new.oneDay' | transloco">
                </div>
                <div class="col-md-3 col-sm-6">
                  <label>
                    {{ 'store-products-new.reception' | transloco }}:
                  </label>
                  <input type="text" formControlName="untilOrderTime" class="time-range-input form-control m-input" [placeholder]="'store-products-new.time' | transloco" [dropSpecialCharacters]="false" [mask]="'00:00'">
                </div>
                <div class="col-md-3 col-sm-6">
                  <label>
                    {{ 'store-products-new.saleAfter' | transloco }}:
                  </label>
                  <input type="text" formControlName="receiveAfterTime" class="time-range-input form-control m-input" [placeholder]="'store-products-new.time' | transloco" [dropSpecialCharacters]="false" [mask]="'00:00'">
                </div>
              </div>
            </div>

            <div class="form-group m-form__group m-form__group--colored">
              <app-price-new [storeProductId]="id" [productInfoId]="product?.productInfo?.id"></app-price-new>
            </div>
          </div>
        </div>

        <div class="modal-footer modal-footer--pad-right">
          <button type="submit" class="btn btn-success">
            {{ 'btn.save' | transloco }}
          </button>

          <button type="button" (click)="closeModal(modal)" class="btn btn-secondary">
            {{ 'btn.cancel' | transloco }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
